const ITEMS = [
    "People worth knowing",
    "Real interests",
    "Deeper connections",
    "Context over swipes",
    "Curiosity first",
    "A more human internet",
];

const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
        {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
                <span className="font-serif2 px-8 text-2xl italic text-[#8A8580] sm:px-12 sm:text-3xl">
                    {item}
                </span>
                <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                        d="M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6L5.6 18.4"
                        stroke="#C7B7FF"
                        strokeWidth="2.4"
                        strokeLinecap="round"
                    />
                </svg>
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="mt-24 overflow-hidden border-y border-[#262422] py-7 sm:mt-32"
    >
        <div className="marquee-track flex w-max">
            <Row hidden={false} />
            <Row hidden={true} />
        </div>
    </div>
);
